import React from "react";
import { Button, Typography } from "@mui/material";
import { Link } from "react-router";
import { AbstractCase } from "../../types/Entities/AbstractCase";
import ProductBoxGrid from "@/src/components/ProductBoxGrid/ProductBoxGrid";
import ProductBox from "@/src/components/ProductBox/ProductBox";

type ServiceWorldSendMessageBoxProps = {
  product: AbstractCase;
};

export default function ServiceWorldSendMessageBox({ product }: ServiceWorldSendMessageBoxProps) {
  return (
    <ProductBox headline={"Nachricht senden"}>
      <ProductBoxGrid
        items={[
          <Typography>Hier können Sie jederzeit direkt eine Frage stellen, weitere Details mitteilen oder uns Dokumente zusenden.</Typography>,
          <Button variant={"outlined"} fullWidth component={Link} to={`/servicewelt/nachrichten/neu?product=${product.name}&productId=${product.id}`}>
            Nachricht schreiben
          </Button>,
        ]}
      />
    </ProductBox>
  );
}
